<template>
  <div class="image-carousel">
    <swiper :options="swiperOption">
      <swiper-slide
        v-for="image in images"
        :key="image.id"
      >
        <div class="image-carousel__slide">
          <img
            v-lazy="image.urls.large"
            :srcset="image.srcset"
            class="image-carousel__image"
            alt=""
          >
          <p
            v-if="image.caption"
            class="image-carousel__caption"
          >
            {{ image.caption }}
          </p>
        </div>
      </swiper-slide>

      <button
        slot="button-prev"
        class="swiper-button-prev"
      />
      <button
        slot="button-next"
        class="swiper-button-next"
      />
      <div
        slot="pagination"
        class="swiper-pagination"
      />
    </swiper>
  </div>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 0,
                paginationType: 'fraction',
                pagination: '.swiper-pagination',
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
            },
        }
    },
}
</script>
